<template>
    <div class="vl-grid vl-grid--align-center">
        <div class="vl-col--9-12 vl-col--12-12--m vl-col--12-12--s vl-col--12-12--xs">
            <form @submit.prevent="validate" id="unknown-epc-form">

                <!-- Woningkenmerken -->
                <section class="section">
                    <h2 class="vl-title--h2">Uw woningkenmerken</h2>

                    <label class="vl-form__label">Mijn woning is een</label>
                    <div class="vl-u-spacer">
                        <div class="vl-grid">
                            <div class="vl-col--3-12 vl-col--6-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': bebouwing === 'open'}">
                                    <label class="vl-radio" for="bebouwing-radio-1">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-open.svg"
                                                 alt="Icoon voor open bebouwing">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="bebouwing-radio-1"
                                               name="bebouwing" value="open"
                                               v-model="bebouwing"/>
                                        <div class="vl-radio__label">
                                            Open bebouwing
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-col--3-12 vl-col--6-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': bebouwing === 'halfopen'}">
                                    <label class="vl-radio" for="bebouwing-radio-2">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-halfopen.svg"
                                                 alt="Icoon voor halfopen bebouwing">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="bebouwing-radio-2"
                                               name="bebouwing" value="halfopen"
                                               v-model="bebouwing"/>
                                        <div class="vl-radio__label">
                                            Halfopen bebouwing
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-col--3-12 vl-col--6-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': bebouwing === 'gesloten'}">
                                    <label class="vl-radio" for="bebouwing-radio-3">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-gesloten.svg"
                                                 alt="Icoon voor gesloten bebouwing">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="bebouwing-radio-3"
                                               name="bebouwing" value="gesloten"
                                               v-model="bebouwing"/>
                                        <div class="vl-radio__label">
                                            Gesloten bebouwing
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-col--3-12 vl-col--6-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': bebouwing === 'appartement'}">
                                    <label class="vl-radio" for="bebouwing-radio-4">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-appartement.svg"
                                                 alt="Icoon voor appartement">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="bebouwing-radio-4"
                                               name="bebouwing" value="appartement"
                                               v-model="bebouwing"/>
                                        <div class="vl-radio__label">
                                            Appartement
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vl-u-spacer" v-if="bebouwing !== 'appartement'">
                        <label for="wk-oppervlakte" class="vl-form__label">
                            En de bewoonbare oppervlakte is
                        </label>
                        <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                              id="tooltip-bewoonbare-oppervlakte"></span>
                        <b-tooltip target="tooltip-bewoonbare-oppervlakte" triggers="hover"
                                   customClass="vl-tooltip">
                            <p class="vl-u-text--italic">
                                <span class="vl-u-text--bold">Bewoonbare oppervlakte</span><br>
                                De bewoonbare oppervlakte van uw woning is de som van alle vloeroppervlakken. Kelders en
                                niet gebruikte zolders horen daar niet bij. Kies de grootte die het beste aanleunt bij
                                uw situatie.
                                <br><br>
                                <span class="vl-u-text--bold">Waarom de bewoonbare oppervlakte?</span><br>
                                Het energielabel wordt mee bepaald door de grootte van uw woning. Op basis van de vorm
                                en de
                                bewoonbare oppervlakte leiden we een eenvoudige geometrie af zoals die
                                gemiddeld het meest voorkomt bij uw type woning. De geometrie van uw eigen woning kan
                                hier sterk van afwijken.
                                <br><br>
                                Liever een gedetailleerde berekening van uw energielabel? Laat een officieel EPC opmaken
                                door een erkend energiedeskundige type A (<a
                                    href="https://www.energiesparen.be/epcparticulier" target="_blank">link</a>) .
                            </p>
                        </b-tooltip>
                        <div class="vl-form-group vl-u-spacer--small">
                            <select name="wk-oppervlakte" id="wk-oppervlakte" :title="selectedOppervlakteText"
                                    class="vl-select vl-select--block select-max-width"
                                    v-model="selectedOppervlakte">
                                <option disabled value="" selected>Maak een keuze</option>
                                <option v-for="oppervlakte in this.oppervlaktes"
                                        :value="oppervlakte.value" :key="oppervlakte.value">
                                    {{ oppervlakte.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedOppervlakte.required">
                                Oppervlakte is verplicht
                            </div>
                        </div>
                    </div>
                    <div class="vl-u-spacer" v-else>
                        <label for="wk-type-appartement" class="vl-form__label">
                            En type appartement is
                        </label>
                        <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                              id="tooltip-type-appartement"></span>
                        <b-tooltip target="tooltip-type-appartement" triggers="hover"
                                   customClass="vl-tooltip">
                            <p class="vl-u-text--italic">
                                <span class="vl-u-text--bold">Type appartement</span><br>
                                Bij een appartement in het midden veronderstellen we enkel voor- en achtergevel.
                                Bij een appartement aan de zijkant veronderstellen we daar nog een zijgevel bij.
                                Bij een dakappartement veronderstellen we voor- en achtergevel en ook een dak.
                                Kies het type dat het best aanleunt bij uw situatie.
                                <br><br>
                                <span class="vl-u-text--bold">Waarom is het type appartement belangrijk?</span><br>
                                Het energielabel wordt mee bepaald door hoeveel verliesoppervlak uw appartement heeft
                                naar buiten. Via het type appartement maken we hiervan een inschatting.
                                <br><br>
                                Liever een gedetailleerde berekening van uw energielabel? Laat een officieel EPC opmaken
                                door een erkend energiedeskundige type A
                                (<a href="https://www.energiesparen.be/epcparticulier" target="_blank">link</a>) .
                            </p>
                        </b-tooltip>
                        <div class="vl-form-group vl-u-spacer--small">
                            <select name="wk-type-appartement" id="wk-type-appartement"
                                    class="vl-select vl-select--block select-max-width"
                                    v-model="selectedAppartementType">
                                <option disabled value="" selected>Maak een keuze</option>
                                <option v-for="appartementType in this.appartementTypes"
                                        :value="appartementType.value" :key="appartementType.value">
                                    {{ appartementType.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedAppartementType.required">
                                Type appartement is verplicht
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Verwarming & hernieuwbare systemen -->
                <section class="section">
                    <h2 class="vl-title--h2">Verwarming &amp; hernieuwbare systemen</h2>
                    <div class="vl-u-spacer">
                        <label for="wk-verwarming" class="vl-form__label">
                            Mijn woning wordt verwarmd met
                            <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                  id="tooltip-verwarming"></span>
                            <b-tooltip target="tooltip-verwarming" triggers="hover"
                                       customClass="vl-tooltip">
                              <p class="vl-u-text--italic">
                                <span class="vl-u-text--bold">Type verwarming</span><br>
                                Indien u uw woning op meerdere manieren verwarmt, kies dan de verwarming die het
                                grootste deel van uw woning verwarmt.
                                <br><br>
                                Bij ketels en een warmtenet veronderstellen we dat er enkel radiatoren of convectoren
                                staan. Bij een volledig elektrische warmtepomp veronderstellen we enkel vloerverwarming,
                                bij een hybride warmtepomp een combinatie van radiatoren/convectoren en vloerverwarming.
                                <br><br>
                                Liever een gedetailleerde berekening van uw energielabel? Laat een officieel EPC opmaken
                                door een erkend energiedeskundige type A
                                (<a href="https://www.vlaanderen.be/energieprestatiecertificaat-epc-bij-verkoop-of-verhuur-van-een-wooneenheid"
                                    target="_blank">link</a>) .
                              </p>
                            </b-tooltip>
                        </label>
                        <div class="vl-form-group vl-u-spacer--small">
                            <select name="wk-verwarming" id="wk-verwarming"
                                    class="vl-select vl-select--block select-max-width"
                                    v-model="selectedVerwarming"
                                    @change="updateVerwarmingDetails()">
                                <option disabled value="">Maak een keuze</option>
                                <option v-for="verwarming in verwarmingen"
                                        :value="verwarming.value" :key="verwarming.value">
                                    {{ verwarming.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedVerwarming.required">
                                Energiedrager verwarming is verplicht
                            </div>
                        </div>
                    </div>
                    <div class="vl-u-spacer"
                         v-if="selectedVerwarming !== '' && selectedVerwarming !== 'Warmtenet'">
                        <label for="wk-verwarming-detail" class="vl-form__label">
                            Mijn verwarming is
                        </label>
                        <div class="vl-form-group vl-u-spacer--small">
                            <select name="wk-verwarming-detail" id="wk-verwarming-detail"
                                    class="vl-select vl-select--block select-max-width"
                                    v-model="selectedVerwarmingDetail"
                                    @change="updateSanitairWarmWaters()">
                                <option disabled value="">Maak een keuze</option>
                                <option v-for="verwarmingDetail in this.verwarmingDetails"
                                        :value="verwarmingDetail.value"
                                        :key="verwarmingDetail.value">
                                    {{ verwarmingDetail.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedVerwarmingDetail.required">
                                Verwarming is verplicht
                            </div>
                        </div>
                    </div>
                    <div class="vl-u-spacer">
                        <label for="wk-sanitair-warm-water" class="vl-form__label">
                            Ik verwarm mijn sanitair warm water met
                            <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                  id="tooltip-sanitair-warm-water"></span>
                            <b-tooltip target="tooltip-sanitair-warm-water" triggers="hover"
                                       customClass="vl-tooltip">
                                <p class="vl-u-text--italic">
                                    <span class="vl-u-text--bold">Sanitair warm water</span><br>
                                    Indien u uw sanitair warm water op meerdere manieren verwarmt, kies dan het type
                                    toestel dat het grootste volume water opwarmt.
                                    <br><br>
                                    Als u sanitair warm water maakt met hetzelfde toestel als voor uw verwarming, dan
                                    veronderstellen we dat er een boiler staat van 150 liter.
                                    Ook bij een elektrische boiler, een warmtepompboiler of een aparte ketel op
                                    stookolie veronderstellen we een boiler van 150 liter.
                                    <br><br>
                                    Enkel als u sanitair warm water maakt met een apart toestel dat werkt op gas,
                                    veronderstellen we een doorstromer (geen boiler).
                                    <br><br>
                                    <span class="vl-u-text--bold">Zonneboiler?</span><br>
                                    Kies hier de manier van bijverwarmen en vink nadien zonneboiler aan.
                                    <br><br>
                                    Liever een gedetailleerde berekening van uw energielabel? Laat een officieel EPC
                                    opmaken door een erkend energiedeskundige type A
                                    (<a href="https://www.energiesparen.be/epcparticulier" target="_blank">link</a>) .
                                </p>
                            </b-tooltip>
                        </label>
                        <div class="vl-form-group vl-u-spacer--small">
                            <select name="wk-sanitair-warm-water" id="wk-sanitair-warm-water"
                                    class="vl-select vl-select--block select-max-width"
                                    v-model="selectedSanitairWarmWater">
                                <option disabled value="">Maak een keuze</option>
                                <option v-for="sanitairWarmWater in this.sanitairWarmWaters"
                                        :value="sanitairWarmWater.value"
                                        :key="sanitairWarmWater.value">
                                    {{ sanitairWarmWater.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedSanitairWarmWater.required">
                                Sanitair warm water is verplicht
                            </div>
                        </div>
                    </div>

                    <strong class="vl-form__label">Mijn hernieuwbare systemen zijn</strong>
                    <div class="vl-grid vl-grid--is-stacked">
                        <div class="vl-col--6-12 vl-col--6-12--m vl-col--1-1--s">
                            <div class="vl-u-spacer--xsmall">
                                <div class="vl-checkbox">
                                    <input type="checkbox" name="wk-zonneboiler" id="wk-zonneboiler"
                                           class="vl-checkbox__toggle"
                                           v-model="zonneboilerCheck"/>
                                    <label class="vl-checkbox__label" for="wk-zonneboiler">
                                        <i class="vl-checkbox__box" aria-hidden="true"></i>
                                        Zonneboiler
                                        <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                              id="tooltip-zonneboiler"></span>
                                        <b-tooltip target="tooltip-zonneboiler" triggers="hover"
                                                   customClass="vl-tooltip">
                                            <p class="vl-u-text--italic">
                                                <span class="vl-u-text--bold">Zonneboiler</span><br>
                                                Voor een eengezinswoning veronderstellen we een zonnecollector-oppervlakte
                                                van 4,8 m², gericht naar het zuiden.
                                                Voor een appartement veronderstellen we een zonnecollector-oppervlakte
                                                van 2,4 m², ook gericht naar het zuiden.
                                                <br><br>
                                                Wilt u in detail weten wat er mogelijk is op uw dak? Raadpleeg de
                                                <a href="https://apps.energiesparen.be/zonnekaart" target="_blank">zonnekaart</a>.
                                                <br><br>
                                                Liever een gedetailleerde berekening van uw energielabel? Laat een
                                                officieel EPC opmaken door een erkend energiedeskundige type A
                                                (<a href="https://www.energiesparen.be/epcparticulier" target="_blank">link</a>)
                                                .
                                            </p>
                                        </b-tooltip>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-u-spacer--xsmall">
                                <label for="wk-pv-installatie" class="vl-checkbox">
                                    <input type="checkbox" name="wk-pv-installatie"
                                           id="wk-pv-installatie" class="vl-checkbox__toggle"
                                           v-model="PVInstallatieCheck"/>
                                    <span class="vl-checkbox__label">
                                        <i class="vl-checkbox__box" aria-hidden="true"></i>
                                        Zonnepanelen
                                        <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                              id="tooltip-pv"></span>
                                        <b-tooltip target="tooltip-pv" triggers="hover" customClass="vl-tooltip">
                                            <p class="vl-u-text--italic">
                                                <span class="vl-u-text--bold">Zonnepanelen</span><br>
                                                Voor een eengezinswoning veronderstellen we 16 m² aan zonnepanelen
                                                (2,7 kWp vermogen), gericht naar het zuiden.
                                                Voor een appartement veronderstellen we 4 m² zonnepanelen (0,7 kWp),
                                                gericht naar het zuiden.
                                                <br><br>
                                                Wilt u in detail weten wat er mogelijk is op uw dak? Raadpleeg de
                                                <a href="https://apps.energiesparen.be/zonnekaart" target="_blank">zonnekaart</a>.
                                                <br><br>
                                                Liever een gedetailleerde berekening van uw energielabel? Laat een
                                                officieel EPC opmaken door een erkend energiedeskundige type A
                                                (<a href="https://www.energiesparen.be/epcparticulier" target="_blank">link</a>)
                                                .
                                            </p>
                                        </b-tooltip>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Ventilatie -->
                <section class="section">
                    <h2 class="vl-title--h2">Ventilatie</h2>
                    <div class="vl-u-spacer">
                        <label for="wk-ventilatie" class="vl-form__label">
                            Mijn woning wordt geventileerd met
                        </label>
                        <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                              id="tooltip-ventilatie"></span>
                        <b-tooltip target="tooltip-ventilatie" triggers="hover" customClass="vl-tooltip">
                            <p class="vl-u-text--italic">
                                <span class="vl-u-text--bold">Mijn ventilatie</span><br>
                                Er bestaan verschillende systemen:
                                <br><br>
                                <span class="vl-u-text--bold">Natuurlijke ventilatie via roosters (A)</span><br>
                                U heeft raamroosters en/of muurroosters waarlangs natuurlijke luchtstroming kan
                                ontstaan.
                                <br><br>
                                <span class="vl-u-text--bold">Mechanische afvoer (C)</span><br>
                                Lucht wordt toegevoerd via raam- of muurroosters en er draait continu een centrale
                                ventilator die vervuilde lucht afvoert naar buiten.
                                <br><br>
                                <span class="vl-u-text--bold">Mechanische afvoer met vraagsturing (C)</span><br>
                                Lucht wordt toegevoerd via raam- of muurroosters en sensoren detecteren of de centrale
                                ventilator moet aanslaan.
                                <br><br>
                                <span class="vl-u-text--bold">Mechanische toe- en afvoer met warmteterugwinning (D)</span><br>
                                Lucht wordt zowel toe- als afgevoerd met behulp van centrale ventilatoren. Een groot deel
                                van de warmte van de afgevoerde lucht wordt gerecupereerd en herbruikt om de (koude)
                                luchttoevoer te verwarmen.
                                <br><br>
                                <span class="vl-u-text--bold">Niets van dit alles?</span><br>
                                Duid dan aan ‘ik heb geen ventilatiesysteem’.
                                <br><br>
                                Liever een gedetailleerde berekening van uw energielabel? Laat een
                                officieel EPC opmaken door een erkend energiedeskundige type A
                                (<a href="https://www.energiesparen.be/epcparticulier" target="_blank">link</a>) .
                            </p>
                        </b-tooltip>
                        <div class="vl-form-group vl-u-spacer--small">
                            <select name="wk-ventilatie" id="wk-ventilatie"
                                    class="vl-select vl-select--block select-max-width"
                                    v-model="selectedVentilatie">
                                <option disabled value="">Maak een keuze</option>
                                <option v-for="ventilatie in ventilaties"
                                        :value="ventilatie.value" :key="ventilatie.value">
                                    {{ ventilatie.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedVentilatie.required">
                                Ventilatie is verplicht
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Isolatiegraad van de woning -->
                <section class="section">
                    <h2 class="vl-title--h2">Isolatiegraad van uw woning</h2>
                    <!-- Dak isolatie -->
                    <div class="vl-u-spacer" v-if="bebouwing !== 'appartement'
                                        || (bebouwing === 'appartement' && selectedAppartementType === 'AppartementDak')">
                        <label class="vl-form__label">Mijn daktypes zijn</label>
                        <div class="vl-grid">
                            <div class="vl-col--3-12 vl-col--4-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': daktype === 'Dak_hellend'}">
                                    <label class="vl-radio" for="daktype-radio-1">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-hellend-dak.svg"
                                                 alt="Icoon voor hellend dak">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="daktype-radio-1"
                                               name="daktype" value="Dak_hellend"
                                               v-model="daktype"/>
                                        <div class="vl-radio__label">
                                            Hellend dak
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-col--3-12 vl-col--4-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': daktype === 'Dak_plat'}">
                                    <label class="vl-radio" for="daktype-radio-2">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-platte-dak.svg"
                                                 alt="Icoon voor plat dak">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="daktype-radio-2"
                                               name="daktype" value="Dak_plat"
                                               v-model="daktype"/>
                                        <div class="vl-radio__label">
                                            Plat dak
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-col--3-12 vl-col--4-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': daktype === 'Gemengd'}">
                                    <label class="vl-radio" for="daktype-radio-3">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-gemengd-dak.svg"
                                                 alt="Icoon voor gemengd dak">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="daktype-radio-3"
                                               name="daktype" value="Gemengd"
                                               v-model="daktype"/>
                                        <div class="vl-radio__label">
                                            Gemengd
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="vl-grid vl-grid--is-stacked vl-u-spacer">
                                <div class="vl-col--4-12 vl-col--4-12--m vl-col--1-1--s vl-u-spacer--xsmall" v-if="daktype !== 'Dak_plat'">
                                    <label for="wk-hellend-dak" class="vl-form__label">
                                        Mijn hellend dak is
                                    </label>
                                    <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                          id="tooltip-hellend-dak"></span>
                                    <b-tooltip target="tooltip-hellend-dak" triggers="hover"
                                               customClass="vl-tooltip">
                                        <p class="vl-u-text--italic">
                                            <span class="vl-u-text--bold">Dakisolatie hellend dak</span><br>
                                            De isolerende waarde van uw dakisolatie hangt niet alleen af van de dikte,
                                            maar ook van het isolatiemateriaal zelf. Voor een hellend dak
                                            veronderstellen we een materiaal met een geleidingscoëfficiënt van
                                            0,04 W/(m²K). Dit komt overeen met minerale wol, rotswol, cellulosevlokken,
                                            XPS-platen of EPS-platen.
                                            <br><br>
                                            Bestaat uw dakisolatie uit PUR-platen, duid dan een grotere dikte aan dan in
                                            werkelijkheid het geval is.
                                            <br><br>
                                            <span class="vl-u-text--bold">Zoldervloer geïsoleerd?</span><br>
                                            Duid dit aan als isolatie in het hellend dak.
                                            <br><br>
                                            Liever een gedetailleerde berekening van uw energielabel? Laat een officieel
                                            EPC opmaken door een erkend energiedeskundige type A
                                            (<a href="https://www.energiesparen.be/epcparticulier"
                                                target="_blank">link</a>) .
                                        </p>
                                    </b-tooltip>
                                    <div class="vl-form-group vl-u-spacer--small">
                                        <select name="wk-hellend-dak" id="wk-hellend-dak"
                                                class="vl-select vl-select--block"
                                                v-model="selectedHellendDak">
                                            <option disabled value="">Maak een keuze</option>
                                            <option v-for="hellendDak in hellendeDaken"
                                                    :value="hellendDak.value"
                                                    :key="hellendDak.value">
                                                {{ hellendDak.text }}
                                            </option>
                                        </select>
                                        <div class="vl-form__error"
                                             v-if="this.$v.$dirty && !this.$v.selectedHellendDak.required">
                                            Hellend dak is verplicht
                                        </div>
                                    </div>
                                </div>
                                <div class="vl-col--4-12 vl-col--4-12--m vl-col--1-1--s vl-u-spacer--xsmall" v-if="daktype !== 'Dak_hellend'">
                                    <label for="wk-plat-dak" class="vl-form__label">
                                        Mijn plat dak is
                                    </label>
                                    <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                          id="tooltip-plat-dak"></span>
                                    <b-tooltip target="tooltip-plat-dak" triggers="hover"
                                               customClass="vl-tooltip">
                                        <p class="vl-u-text--italic">
                                            <span class="vl-u-text--bold">Dakisolatie plat dak</span><br>
                                            De isolerende waarde van uw dakisolatie hangt niet alleen af van de dikte,
                                            maar ook van het isolatiemateriaal zelf. Voor een plat dak
                                            veronderstellen we een materiaal met een geleidingscoëfficiënt van
                                            0,030 W/(m²K). Dit komt overeen met PUR-platen.
                                            <br><br>
                                            Bestaat uw dakisolatie uit minerale wol, rotswol, XPS-, EPS-platen of
                                            cellulosevlokken, duid dan een kleinere dikte aan dan in werkelijkheid het
                                            geval is.
                                            <br><br>
                                            <span class="vl-u-text--bold">Zoldervloer geïsoleerd?</span><br>
                                            Duid dit aan als isolatie in het hellend dak.
                                            <br><br>
                                            Liever een gedetailleerde berekening van uw energielabel? Laat een officieel
                                            EPC opmaken door een erkend energiedeskundige type A
                                            (<a href="https://www.energiesparen.be/epcparticulier"
                                                target="_blank">link</a>) .
                                        </p>
                                    </b-tooltip>
                                    <div class="vl-form-group vl-u-spacer--small">
                                        <select name="wk-plat-dak" id="wk-plat-dak"
                                                class="vl-select vl-select--block"
                                                v-model="selectedPlatDak">
                                            <option disabled value="">Maak een keuze</option>
                                            <option v-for="platDak in platteDaken"
                                                    :value="platDak.value" :key="platDak.value">
                                                {{ platDak.text }}
                                            </option>
                                        </select>
                                        <div class="vl-form__error"
                                             v-if="this.$v.$dirty && !this.$v.selectedPlatDak.required">
                                            Plat dak is verplicht
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>

                    <!-- Vloer isolatie -->
                    <div class="vl-u-spacer" v-if="bebouwing !== 'appartement'">
                        <label class="vl-form__label">Mijn vloertypes zijn</label>
                        <div class="vl-grid">
                            <div class="vl-col--3-12 vl-col--4-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': vloertype === 'VolleGrond'}">
                                    <label class="vl-radio" for="vloertype-radio-1">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-grond.svg"
                                                 alt="Icoon voor vloer op volle grond">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="vloertype-radio-1"
                                               name="vloertype" value="VolleGrond"
                                               v-model="vloertype"/>
                                        <div class="vl-radio__label">
                                            Vloer op volle grond
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-col--3-12 vl-col--4-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': vloertype === 'BovenKelder'}">
                                    <label class="vl-radio" for="vloertype-radio-2">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-kelder.svg"
                                                 alt="Icoon voor vloer boven kelder">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="vloertype-radio-2"
                                               name="vloertype" value="BovenKelder"
                                               v-model="vloertype"/>
                                        <div class="vl-radio__label">
                                            Vloer boven kelder
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="vl-col--3-12 vl-col--4-12--m vl-col--1-1--s">
                                <div class="radio-wrapper"
                                     :class="{'radio-wrapper--selected': vloertype === 'Gemengd'}">
                                    <label class="vl-radio" for="vloertype-radio-3">
                                        <span class="radio__icon vl-u-align-center">
                                            <img src="@/assets/icons/icon-grond-kelder.svg"
                                                 alt="Icoon voor gemengde vloer">
                                        </span>
                                        <input class="vl-radio__toggle" type="radio" id="vloertype-radio-3"
                                               name="vloertype" value="Gemengd"
                                               v-model="vloertype"/>
                                        <div class="vl-radio__label">
                                            Gemengd
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="vl-grid vl-grid--is-stacked vl-u-spacer">
                                <div class="vl-col--4-12 vl-col--4-12--m vl-col--1-1--s vl-u-spacer--xsmall" v-if="vloertype !== 'BovenKelder'">
                                    <label for="wk-volle-grond" class="vl-form__label">
                                        Mijn vloer op volle grond is
                                    </label>
                                    <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                          id="tooltip-vloer-volle-grond"></span>
                                    <b-tooltip target="tooltip-vloer-volle-grond" triggers="hover"
                                               customClass="vl-tooltip">
                                        <p class="vl-u-text--italic">
                                            <span class="vl-u-text--bold">Vloerisolatie</span><br>
                                            De isolerende waarde van uw vloerisolatie hangt niet alleen af van de dikte,
                                            maar ook van het isolatiemateriaal zelf. Voor een vloer
                                            veronderstellen we een materiaal met een geleidingscoëfficiënt
                                            van 0,030 W/(m²K). Dit komt overeen met PUR-platen.
                                            <br><br>
                                            Bestaat uw vloerisolatie uit minerale wol, rotswol, cellulosevlokken,
                                            XPS- of EPS-platen, duid dan een kleinere dikte aan dan in werkelijkheid het geval is.
                                            <br><br>
                                            Liever een gedetailleerde berekening van uw energielabel? Laat een officieel
                                            EPC opmaken door een erkend energiedeskundige type A
                                            (<a href="https://www.energiesparen.be/epcparticulier"
                                                target="_blank">link</a>) .
                                        </p>
                                    </b-tooltip>
                                    <div class="vl-form-group vl-u-spacer--small">
                                        <select name="wk-volle-grond" id="wk-volle-grond"
                                                class="vl-select vl-select--block"
                                                v-model="selectedVloerVolleGrond">
                                            <option disabled value="">Maak een keuze</option>
                                            <option v-for="vloer in vloerenVolleGrond"
                                                    :value="vloer.value"
                                                    :key="vloer.value">
                                                {{ vloer.text }}
                                            </option>
                                        </select>
                                        <div class="vl-form__error"
                                             v-if="this.$v.$dirty && !this.$v.selectedVloerVolleGrond.required">
                                            Vloer op volle grond is verplicht
                                        </div>
                                    </div>
                                </div>
                                <div class="vl-col--4-12 vl-col--4-12--m vl-col--1-1--s vl-u-spacer--xsmall" v-if="vloertype !== 'VolleGrond'">
                                    <label for="wk-boven-kelder" class="vl-form__label">
                                        Mijn vloer boven kelder is
                                    </label>
                                    <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                          id="tooltip-vloer-boven-kelder"></span>
                                    <b-tooltip target="tooltip-vloer-boven-kelder" triggers="hover"
                                               customClass="vl-tooltip">
                                        <p class="vl-u-text--italic">
                                            <span class="vl-u-text--bold">Vloerisolatie</span><br>
                                            De isolerende waarde van uw vloerisolatie hangt af van de dikte, maar ook van het
                                            isolatiemateriaal zelf. Voor een vloer veronderstellen we een materiaal met
                                            een geleidingscoëfficiënt van 0,030 W/(m²K). Dit komt overeen met
                                            PUR-platen.
                                            <br><br>
                                            Bestaat uw vloerisolatie uit minerale wol, rotswol, cellulosevlokken,
                                            XPS- of EPS-platen, duid dan een kleinere dikte aan dan in werkelijkheid het geval is.
                                            <br><br>
                                            Liever een gedetailleerde berekening van uw energielabel? Laat een officieel
                                            EPC opmaken door een erkend energiedeskundige type A
                                            (<a href="https://www.energiesparen.be/epcparticulier"
                                                target="_blank">link</a>) .
                                        </p>
                                    </b-tooltip>
                                    <div class="vl-form-group vl-u-spacer--small">
                                        <select name="wk-boven-kelder" id="wk-boven-kelder"
                                                class="vl-select vl-select--block"
                                                v-model="selectedVloerBovenKelder">
                                            <option disabled value="">Maak een keuze</option>
                                            <option v-for="vloer in vloerenBovenKelder"
                                                    :value="vloer.value" :key="vloer.value">
                                                {{ vloer.text }}
                                            </option>
                                        </select>
                                        <div class="vl-form__error"
                                             v-if="this.$v.$dirty && !this.$v.selectedVloerBovenKelder.required">
                                            Vloer boven kelder is verplicht
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>

                    <div class="vl-grid vl-grid--is-stacked vl-u-spacer">
                        <div class="vl-col--4-12 vl-col--4-12--m vl-col--1-1--s vl-u-spacer--xsmall">
                            <div class="vl-u-align-center">
                                <img src="@/assets/icons/icon-buitenmuur.svg" height="72"
                                     alt="Icoon voor buitenmuur"><br>
                                <label for="wk-buitenmuur" class="vl-form__label">Mijn buitenmuur is
                                    <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                          id="tooltip-buitenmuur"></span>
                                    <b-tooltip target="tooltip-buitenmuur" triggers="hover"
                                               customClass="vl-tooltip">
                                        <p class="vl-u-text--italic">
                                            <span class="vl-u-text--bold">Muurisolatie</span><br>
                                            De isolerende waarde van uw muurisolatie hangt af van de dikte, maar ook van het
                                            isolatiemateriaal zelf. Voor een muur veronderstellen we een materiaal met
                                            een geleidingscoëfficiënt van 0,040 W/(m²K). Dit komt overeen met minerale
                                            wol, rotswol, cellulosevlokken, XPS-platen of EPS-platen.
                                            <br><br>
                                            Bestaat uw muurisolatie uit PUR-platen, duid dan een grotere dikte aan dan
                                            in werkelijkheid het geval is.
                                            <br><br>
                                            Liever een gedetailleerde berekening van uw energielabel? Laat een officieel
                                            EPC opmaken door een erkend energiedeskundige type A
                                            (<a href="https://www.energiesparen.be/epcparticulier"
                                                target="_blank">link</a>) .
                                        </p>
                                    </b-tooltip>
                                </label>
                            </div>
                            <select name="wk-buitenmuur" id="wk-buitenmuur"
                                    class="vl-select vl-select--block" data-required="true"
                                    v-model="selectedBuitenmuur">
                                <option disabled value="">Maak een keuze</option>
                                <option v-for="buitenmuur in buitenmuren"
                                        :value="buitenmuur.value" :key="buitenmuur.value">
                                    {{ buitenmuur.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedBuitenmuur.required">
                                Buitenmuur is verplicht
                            </div>
                        </div>

                        <div class="vl-col--4-12 vl-col--4-12--m vl-col--1-1--s vl-u-spacer--xsmall">
                            <div class="vl-u-align-center">
                                <img src="@/assets/icons/icon-vensters.svg" height="72"
                                     alt="Icoon voor vensters"><br>
                                <label for="wk-vensters" class="vl-form__label">
                                    De beglazing van mijn vensters is
                                    <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                          id="tooltip-vensters"></span>
                                    <b-tooltip target="tooltip-vensters" triggers="hover"
                                               customClass="vl-tooltip">
                                        <p class="vl-u-text--italic">
                                            <span class="vl-u-text--bold">Beglazing</span><br>
                                            Indien u verschillende soorten beglazing heeft, kies dan het type dat in
                                            oppervlakte het meeste voorkomt.
                                            <br><br>
                                            De U-waarde van het glas beschrijft de isolerende waarde: hoe lager de
                                            U-waarde, hoe beter het glas isoleert.
                                            <br><br>
                                            Liever een gedetailleerde berekening van uw energielabel? Laat een officieel
                                            EPC opmaken door een erkend energiedeskundige type A
                                            (<a href="https://www.energiesparen.be/epcparticulier"
                                                target="_blank">link</a>) .
                                        </p>
                                    </b-tooltip>
                                </label>
                            </div>
                            <select name="wk-vensters" id="wk-vensters"
                                    class="vl-select vl-select--block" data-required="true"
                                    v-model="selectedVenster">
                                <option disabled value="">Maak een keuze</option>
                                <option v-for="venster in vensters"
                                        :value="venster.value" :key="venster.value">
                                    {{ venster.text }}
                                </option>
                            </select>
                            <div class="vl-form__error"
                                 v-if="this.$v.$dirty && !this.$v.selectedVenster.required">
                                Beglazing vensters verplicht
                            </div>
                        </div>
                    </div>

                    <button type="submit" class="vl-button vl-button--large">
                        Bereken mijn indicatief EPC-label
                    </button>
                    <div class="vl-form__error"
                         v-if="this.$v.$invalid && this.submitStatus === 'ERROR'">
                        Vul het formulier correct in aub
                    </div>
                </section>
            </form>
        </div>
    </div>
</template>

<script>
    import {required, requiredUnless} from "vuelidate/lib/validators";
    import VueScrollTo from 'vue-scrollto';

    export default {
        name: "UnknownEpcForm",
        data() {
            return {
                submitStatus: null,
                bebouwing: 'open',
                selectedOppervlakte: '',
                selectedAppartementType: '',
                appartementTypes: [
                    {text: 'Appartement in het midden', value: 'AppartementIngesloten'},
                    {text: 'Appartement aan de zijkant', value: 'AppartementZijgevel'},
                    {text: 'Dakappartement', value: 'AppartementDak'},
                ],
                selectedVerwarming: '',
                verwarmingen: [
                    {text: 'Gas', value: 'Gas'},
                    {text: 'Elektriciteit / Warmtepomp', value: 'Elektriciteit'},
                    {text: 'Stookolie', value: 'Stookolie'},
                    {text: 'Pellets', value: 'Pellets'},
                    {text: 'Hout', value: 'Hout'},
                    {text: 'Warmtenet', value: 'Warmtenet'},
                ],
                selectedVerwarmingDetail: '',
                verwarmingDetails: [],
                selectedSanitairWarmWater: '',
                sanitairWarmWaters: [
                    {text: 'Zelfde toestel als ruimteverwarming', value: 'zelfde toestel als ruimteverwarming'},
                    {text: 'Gas', value: 'gas'},
                    {text: 'Stookolie', value: 'stookolie'},
                    {text: 'Elektrische boiler', value: 'elektrische boiler'},
                    {text: 'Warmtepompboiler', value: 'warmtepompboiler'},
                ],
                zonneboilerCheck: false,
                PVInstallatieCheck: false,
                selectedVentilatie: '',
                ventilaties: [
                    {text: 'Ik heb geen ventilatiesysteem', value: 'geen'},
                    {text: 'Natuurlijke ventilatie via roosters (A)', value: 'A'},
                    {text: 'Mechanische afvoer (C)', value: 'C'},
                    {text: 'Mechanische afvoer met vraagsturing (C)', value: 'Cwtw'},
                    {text: 'Mechanische toe- en afvoer met warmteterugwinning (D)', value: 'Dwtw'},
                ],
                daktype: 'Dak_hellend',
                selectedHellendDak: '',
                hellendeDaken: [
                    {text: 'Niet geïsoleerd', value: 'niet'},
                    {text: 'Licht geïsoleerd (rond 5 cm isolatie)', value: 'licht'},
                    {text: 'Matig geïsoleerd (rond 14 cm isolatie)', value: 'matig'},
                    {text: 'Sterk geïsoleerd (rond 25 cm isolatie en meer)', value: 'sterk'},
                ],
                selectedPlatDak: '',
                platteDaken: [
                    {text: 'Niet geïsoleerd', value: 'niet'},
                    {text: 'Licht geïsoleerd (rond 3 cm isolatie)', value: 'licht'},
                    {text: 'Matig geïsoleerd (rond 8 cm isolatie)', value: 'matig'},
                    {text: 'Sterk geïsoleerd (rond 15 cm isolatie en meer)', value: 'sterk'},
                ],
                vloertype: 'VolleGrond',
                selectedVloerVolleGrond: '',
                vloerenVolleGrond: [
                    {text: 'Niet geïsoleerd', value: 'niet'},
                    {text: 'Licht geïsoleerd (rond 3 cm isolatie)', value: 'licht'},
                    {text: 'Matig geïsoleerd (rond 7 cm isolatie)', value: 'matig'},
                    {text: 'Sterk geïsoleerd (rond 12 cm isolatie en meer)', value: 'sterk'},
                ],
                selectedVloerBovenKelder: '',
                vloerenBovenKelder: [
                    {text: 'Niet geïsoleerd', value: 'niet'},
                    {text: 'Matig geïsoleerd (rond 3 cm isolatie)', value: 'matig'},
                    {text: 'Sterk geïsoleerd (rond 8 cm isolatie en meer)', value: 'sterk'},
                ],
                selectedBuitenmuur: '',
                buitenmuren: [
                    {text: 'Niet geïsoleerd, ik heb een spouw', value: 'nietMetSpouw'},
                    {text: 'Niet geïsoleerd, ik heb geen spouw', value: 'nietZonderSpouw'},
                    {text: 'Licht geïsoleerd (rond 3 cm isolatie)', value: 'licht'},
                    {text: 'Matig geïsoleerd (rond 7 cm isolatie)', value: 'matig'},
                    {text: 'Sterk geïsoleerd (rond 16 cm isolatie en meer)', value: 'sterk'},
                ],
                selectedVenster: '',
                vensters: [
                    {text: 'Enkel glas', value: 'enkel'},
                    {text: 'Dubbel glas (U = 2.8)', value: 'dubbel'},
                    {text: 'Hoogrendementsglas (U=1.0 of 1.1)', value: 'HR'},
                    {text: 'Driedubbele beglazing (U=0.8)', value: 'driedubbel'},
                ]
            }
        },
        computed: {
            selectedOppervlakteText() {
                return this.selectedOppervlakte !== '' ? this.oppervlaktes.filter((o) => o.value === this.selectedOppervlakte)[0].text : '';

            },
            oppervlaktes() {
                if (this.bebouwing === 'open') {
                    return [
                        {text: 'Klein (~150 m²)', value: 'Klein'},
                        {text: 'Gemiddeld (~200 m²)', value: 'Gemiddeld'},
                        {text: 'Groot (~280 m²)', value: 'Groot'},
                    ];
                } else if (this.bebouwing === 'halfopen') {
                    return [
                        {text: 'Klein (~130 m²)', value: 'Klein'},
                        {text: 'Gemiddeld (~180 m²)', value: 'Gemiddeld'},
                        {text: 'Groot (~240 m²)', value: 'Groot'},
                    ];
                } else {
                    return [
                        {text: 'Klein (~120 m²)', value: 'Klein'},
                        {text: 'Gemiddeld (~160 m²)', value: 'Gemiddeld'},
                        {text: 'Groot (~200 m²)', value: 'Groot'},
                    ];
                }
            },
        },
        validations: {
            bebouwing: {required,},
            selectedOppervlakte: {
                required: requiredUnless(function () {
                    return this.bebouwing === 'appartement';
                }),
            },
            selectedAppartementType: {
                required: requiredUnless(function () {
                    return this.bebouwing !== 'appartement';
                }),
            },
            selectedVerwarming: {required,},
            selectedVerwarmingDetail: {
                required: requiredUnless(function () {
                    return this.selectedVerwarming === 'Warmtenet';
                }),
            },
            selectedSanitairWarmWater: {required,},
            selectedVentilatie: {required,},
            selectedHellendDak: {
                required: requiredUnless(function () {
                    return (this.bebouwing === 'appartement' && this.selectedAppartementType !== 'AppartementDak')
                        || this.daktype === 'Dak_plat';
                }),
            },
            selectedPlatDak: {
                required: requiredUnless(function () {
                    return (this.bebouwing === 'appartement' && this.selectedAppartementType !== 'AppartementDak')
                        || this.daktype === 'Dak_hellend';
                }),
            },
            selectedVloerVolleGrond: {
                required: requiredUnless(function () {
                    return this.bebouwing === 'appartement'
                        || this.vloertype === 'BovenKelder';
                }),
            },
            selectedVloerBovenKelder: {
                required: requiredUnless(function () {
                    return this.bebouwing === 'appartement'
                        || this.vloertype === 'VolleGrond';
                }),
            },
            selectedBuitenmuur: {required,},
            selectedVenster: {required,},
        },
        methods: {
            validate() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = 'ERROR';
                    this.$nextTick(() => this.focusFirstStatus());
                } else {
                    if (this.bebouwing === 'appartement') {
                        this.emitSetAppartment(true);
                    } else {
                        this.emitSetAppartment(false);
                    }
                    this.emitSubmitClicked();
                }
            },
            focusFirstStatus() {
                this.$nextTick(() => {
                    VueScrollTo.scrollTo('#unknown-epc-form .vl-form__error', 800, {offset: -350, cancelable: false});
                })
            },
            emitSetAppartment(value) {
                this.$emit('setAppartment', value);
            },
            emitSubmitClicked() {
                this.$emit('submitClicked', this);
            },
            updateVerwarmingDetails() {
              switch (this.selectedVerwarming) {
                case 'Elektriciteit':
                  this.verwarmingDetails = [
                    {text: 'Elektrische verwarming (direct/accumulatie)', value: 'elektrische weerstandsverwarming'},
                    {text: 'Warmtepomp lucht/lucht', value: 'elektrische warmtepomp lucht-lucht'},
                    {text: 'Warmtepomp lucht/water', value: 'elektrische warmtepomp lucht-water'},
                    {text: 'Warmtepomp bodem/water', value: 'elektrische warmtepomp bodem-water'},
                  ];
                  break;
                case 'Gas':
                  this.verwarmingDetails = [
                    {text: 'Hybride warmtepomp', value: 'hybride warmtepomp'},
                    {text: 'Condenserende ketel', value: 'condenserende ketel'},
                    {text: 'Niet-condenserende ketel', value: 'niet-condenserende ketel'},
                    {text: 'Kachel(s)', value: 'kachel'},
                  ];
                  break;
                case 'Stookolie':
                  this.verwarmingDetails = [
                    {text: 'Hybride warmtepomp', value: 'hybride warmtepomp'},
                    {text: 'Condenserende ketel', value: 'condenserende ketel'},
                    {text: 'Niet-condenserende ketel', value: 'niet-condenserende ketel'},
                    {text: 'Kachel(s)', value: 'kachel'},
                  ];
                  break;
                default:
                  this.verwarmingDetails = [
                    {text: 'Condenserende ketel', value: 'condenserende ketel'},
                    {text: 'Niet-condenserende ketel', value: 'niet-condenserende ketel'},
                    {text: 'Kachel(s)', value: 'kachel'},
                  ];
                  break;
              }
                this.selectedVerwarmingDetail = '';
                this.updateSanitairWarmWaters();
            },
            updateSanitairWarmWaters() {
                this.sanitairWarmWaters = this.sanitairWarmWaters.filter(function (sanitairWarmWater) {
                    return sanitairWarmWater.value !== 'zelfde toestel als ruimteverwarming';
                });
                if (this.selectedVerwarmingDetail !== 'kachel' &&
                    this.selectedVerwarmingDetail !== 'elektrische weerstandsverwarming' &&
                    this.selectedVerwarmingDetail !== 'elektrische warmtepomp lucht-lucht') {
                    this.sanitairWarmWaters.unshift({
                            text: 'Zelfde toestel als ruimteverwarming',
                            value: 'zelfde toestel als ruimteverwarming'
                        },
                    );
                }
                this.selectedSanitairWarmWater = '';
            },
        },
    }
</script>